<template>
  <div class="out">
    <div class="title">
      <div class="out-frame">
        <div class="left-menu">
            <ul>
                <li><h2>招聘岗位</h2></li>
                <li><h3>产品 <img src="../assets/arrow.png"></h3></li>
                <ul class="child">
                    <li @click="changeJob(1)">产品经理</li>
                    <li @click="changeJob(2)" style="pointer-events:none"><s>产品测试</s></li>
                </ul>
            </ul>
            <ul>
                <li><h3>运营 <img src="../assets/arrow.png"></h3></li>
                <ul class="child">
                    <li @click="changeJob(3)" style="pointer-events:none"><s>技术支持</s></li>
                    <li @click="changeJob(4)" style="pointer-events:none"><s>实施交付</s></li>
                    <li @click="changeJob(5)" style="pointer-events:none"><s>售前顾问</s></li>
                </ul>
            </ul>
            <ul>
                <li><h3>技术 <img src="../assets/arrow.png"></h3></li>
                <ul class="child">
                    <!-- <li @click="changeJob(6)">技术架构</li> -->
                    <li @click="changeJob(7)">JAVA开发工程师</li>
                    <li @click="changeJob(8)" style="pointer-events:none"><s>前端开发工程师</s></li>
                </ul>
            </ul>
            <ul>
                <li><h3>市场 <img src="../assets/arrow.png"></h3></li>
                <ul class="child">
                    <li @click="changeJob(9)" style="pointer-events:none"><s>市场推广</s></li>
                    <li @click="changeJob(10)" style="pointer-events:none"><s>产品销售</s></li>
                </ul>
            </ul>
        </div>
        <div class="right-content" v-if="job===1">
            <h2 style="color:rgb(26,132,236)">产品经理</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、调研、挖掘、分析客户需求，梳理客户业务逻辑；准确抽象出产品需求，合理判断需求的优先级，并维护产品需求池</p>
                    <p>2、使用原型、流程图、PRD等方法将需求转化成可供需求方、设计和开发使用的文档，并与各方沟通确认</p>
                    <p>3、规划管理产品进度，推动产品的技术实现，把控产品实施质量和效率</p>
                    <p>4、对于所负责的项目结果进行数据分析，完善产品并且不断改进用户体验和提出优化建议</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、大学本科及以上学历，具有1-3年产品经理工作经验；</p>
                    <p>2、熟悉互联网行业，具有产品从规划到上线的完整经验优先；</p>
                    <p>3、良好的语言表达能力，归纳能力及沟通能力，文档写作能力；</p>
                    <p>4、具有团队合作精神和良好的组织协调能力，跟踪及协调研发及交付各环节，确保产品进度及质量；</p>
                    <p>5、熟练使用Axure、VISIO、UML等产品分析和规划工具；</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、拥有PMP资格认证</p>
                </div>
                <h5 style="font-weight:bold; color: red">简历请投递至邮箱：123@123.com</h5>
            </div>
        </div>
        <div class="right-content" v-if="job===2">
            <h2 style="color:rgb(26,132,236)">这是职位2</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
        </div>
        <div class="right-content" v-if="job===3">
            <h2 style="color:rgb(26,132,236)">这是职位3</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
        </div>
        <div class="right-content" v-if="job===4">
            <h2 style="color:rgb(26,132,236)">这是职位4</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
        </div>
        <div class="right-content" v-if="job===5">
            <h2 style="color:rgb(26,132,236)">这是职位5</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
        </div>
        <div class="right-content" v-if="job===6">
            <h2 style="color:rgb(26,132,236)">这是职位6</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
        </div>
        <div class="right-content" v-if="job===7">
            <h2 style="color:rgb(26,132,236)">JAVA开发工程师</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、根据项目要求，编写代码实现产品功能，完成项目开发，撰写相关文档，参与需求分析；</p>
                    <p>2、负责核心技术问题的攻关，系统优化，协助解决项目开发过程中的技术难题；</p>
                    <p>3、配合项目的整体计划和安排，参与相关技术培训和指导；</p>
                    <p>4、参与项目实施，做好沟通协调工作；</p>
                    <p>5、系统业务功能编码实现，重构、功能升级和解决bug；</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、本科及以上学历，具备1-3年java开发经验；</p>
                    <p>2、具有良好JAVA基础，数据结构、基础算法、设计模式等知识；</p>
                    <p>3、有大型分布式、高并发、高负载、高可用性系统设计和稳定性经验；</p>
                    <p>4、熟练应用Spring，MyBatis，Spring Boot，Spring Cloud等框架；</p>
                    <p>5、熟练掌握MySQL、Oracle等数据库的开发应用，能写出高效的SQL代码；</p>
                    <p>6、熟悉Redis，Memcache，ECache一种或多种缓存技术；</p>
                    <p>7、熟悉ActiveMQ，Kafka一种或多种消息中间件；</p>
                    <p>8、熟悉Linux操作系统，熟悉Maven、Git；</p>
                    <p>9、具备较强的学习能力和解决问题能力，有较强的协调、沟通能力和团队精神。</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red"></h5>
                <div class="inner-text">
                    <!-- <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p> -->
                </div>
                <h5 style="font-weight:bold; color: red">简历请投递至邮箱：123@123.com</h5>
            </div>
        </div>
        <div class="right-content" v-if="job===8">
            <h2 style="color:rgb(26,132,236)">这是职位8</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
        </div>
        <div class="right-content" v-if="job===9">
            <h2 style="color:rgb(26,132,236)">这是职位9</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
        </div>
        <div class="right-content" v-if="job===10">
            <h2 style="color:rgb(26,132,236)">这是职位10</h2>
            <hr class="my-4" style="width:800px">
            <p style="text-align:right">工作地点：苏州</p>
            <br>
            <h1></h1>
            <div class="title2">
                <h4 style="border-left:3px solid blue; padding:8px 10px 8px 10px; background-color:skyblue">职位职责</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h4 style="border-left:3px solid orange; padding:8px 10px 8px 10px; background-color:rgba(255,165,0,0.5)">任职要求</h4>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
            </div>
            <div class="title2">
                <h5 style="font-weight:bold; color: red">符合以下条件者优先考虑</h5>
                <div class="inner-text">
                    <p>1、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>2、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>3、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                    <p>4、Lorem ipsum dolor sit amet consectetur, adipisicing elit. Iure eligendi culpa quae accusamus qui enim ab ad adipisci consectetur facilis.</p>
                </div>
                <h5 style="font-weight:bold; color: red">简历请投递至邮箱：123@123.com</h5>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'jobHiring',
  data () {
    return {
      job: 1
    }
  },
  methods: {
    changeJob: function (x) {
      this.job = x
      console.log(this.job)
    }
  }
}
</script>

<style scoped>
.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.title {
  text-align: center;
  margin: 0 auto;
}

.out-frame {
  width: 100%;
  display: flex;
  /* position: relative; */
}

.left-menu {
    /* width: 500px; */
    min-width: 300px;
    background-color: #f8f8f8;
    padding-right: 7rem;
    padding-top: 100px;
    padding-left: 130px;
    /* position: absolute;
    top: 0;
    right: 50%;
    bottom: 0;
    width: 50%;
    margin-right: 350px;
    background: #f8f8f8; */
}

@media screen and (max-width: 1400px) {
    .left-menu {
        padding-left:0;
    }
}

.right-content {
    /* position: absolute; */
    /* width:800px; */
    padding-left: 100px;
    padding-top: 100px;
    text-align: left;
}

li {
    list-style: none;
    text-align: left;
    padding: 10px 0 10px 0;
    /* padding-left: 10%; */
}

.child li {
    cursor:pointer;
}

.child li:hover {
    color: skyblue;
}

.title2 {
    /* width: 140px; */
    /* height:60px; */
}

.title2 h4 {
    width: 120px;
}
.inner-text {
    width: 800px;
    height:250px;
    padding-left:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobHiring.vue